/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import { Card, Row, Col, Form } from "antd";
import PageToolbar from "../../components/PageToolbar";
import GenericSelectorBranches from "../../components/GenericSelectorBranches";
import DateTimePicker from "../../components/DateTimePicker";
import ReportTypeButton from "../../components/ReportTypeButton";
import moment from "moment";


class ReportPaymentsAndSales extends Component {
    constructor(props: Props) {
        super(props);
        let firstDay = moment().format("YYYY-MM-01")
        this.state = {
            _branchList: "",
            _fromDate: firstDay,
            _toDate: moment(firstDay).add(1, "month").add(-1, "day").format("YYYY-MM-DD"),
            reportName: "reports/PaymentsAndSales",
        };
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate(prevProps) {
        document.title = "Cash On Tab - " + this.getText(21745);

        if (prevProps.ui.favoriteParams !== this.props.ui.favoriteParams) {
            this.setState(this.props.ui.favoriteParams)
        }
    }

    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
            width: window.innerWidth > 800 ? 800 : "95%",
            margin: "auto"
        };


        return (<div style={divStyle}>
            <Card title={(<PageToolbar title={gt(21745)} showsearch={false} actionButtons={[]} />)}>
                <Form.Item label={gt(21746)} required validateStatus={this.state._branchList ? "success" : "error"}>
                    <GenericSelectorBranches
                        {...this.props} multi
                        value={this.state._branchList ? this.state._branchList.split(",") : []}
                        onChange={e => { this.setState({ _branchList: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>
                <Row>
                    <Col span={12}>
                        <Form.Item label={gt(21747)} required validateStatus={this.state._fromDate ? "success" : "error"}>
                            <DateTimePicker
                                format="DD/MM/YYYY"
                                value={this.state._fromDate}
                                onChange={e => { this.setState({ _fromDate: e }) }}
                                maxDate={this.state._toDate}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label={gt(21748)} required validateStatus={this.state._toDate ? "success" : "error"}>
                            <DateTimePicker
                                format="DD/MM/YYYY"
                                value={this.state._toDate}
                                onChange={e => { this.setState({ _toDate: e }) }}
                                minDate={this.state._fromDate}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <ReportTypeButton
                    {...this.props}
                    params={this.state}
                    datesToFavorites={[
                        { field: '_fromDate', label: gt(21747) },
                        { field: '_toDate', label: gt(21748) },
                    ]}
                    favoriteSave
                    disabled={!this.state._branchList || !this.state._fromDate || !this.state._toDate}
                />
            </Card>
        </div>)
    }

}

export default ReportPaymentsAndSales;